export const type = [
  {
    type: 'ACC',
    name: '调节训练',
  },
  {
    type: 'ST',
    name: '刺激训练',
  },
  {
    type: 'EX',
    name: '精细训练',
  },
  {
    type: 'PG',
    name: '后像训练',
  },
  {
    type: 'GB',
    name: 'Gabor训练',
  },
  {
    type: 'MFBF',
    name: '脱抑制训练',
  },
  {
    type: 'SV',
    name: '同时视训练',
  },
  {
    type: 'FU',
    name: '集合训练',
  },
  {
    type: 'DV',
    name: '散开训练',
  },
  {
    type: 'STE',
    name: '立体视训练',
  },
  {
    type: 'PUR',
    name: '追随训练',
  },
  {
    type: 'SAC',
    name: '扫视训练',
  },
  {
    type: 'DMO',
    name: '眼肌训练',
  },
  {
    type: 'SZJ',
    name: '视知觉训练',
  },
  {
    type: 'CON',
    name: '专注力训练',
  },
  {
    type: 'VS',
    name: '视觉技巧',
  },
  {
    type: 'DR',
    name: '多人训练',
  },
  {
    type: 'EXAM',
    name: '视功能检查',
  },
]
